function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.83691 6.78653C1.33393 6.78653 0.92618 7.19428 0.92618 7.69727C0.92618 8.20025 1.33393 8.608 1.83691 8.608V6.78653ZM62.4809 8.34125C62.8366 7.98559 62.8366 7.40894 62.4809 7.05328L56.685 1.25741C56.3294 0.901742 55.7527 0.901742 55.3971 1.25741C55.0414 1.61307 55.0414 2.18971 55.3971 2.54538L60.5489 7.69727L55.3971 12.8492C55.0414 13.2048 55.0414 13.7815 55.3971 14.1371C55.7527 14.4928 56.3294 14.4928 56.685 14.1371L62.4809 8.34125ZM1.83691 8.608H61.8369V6.78653H1.83691V8.608Z",
  fill: "#5B5B5B"
});

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 15,
    viewBox: "0 0 63 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.443709fa.svg";
export { ForwardRef as ReactComponent };